import { endOfMonth, startOfMonth, startOfYear, subMonths } from "date-fns";
import { DateRangeOptions } from "./types";
const getDateRangeFromOption = (dateRangeOptions) => {
    const now = new Date();
    switch (dateRangeOptions) {
        case DateRangeOptions.CURRENT_MONTH: {
            return {
                appliedFromDate: startOfMonth(now),
                appliedToDate: now,
            };
        }
        case DateRangeOptions.PREVIOUS_MONTH: {
            const previousMonth = subMonths(now, 1);
            return {
                appliedFromDate: startOfMonth(previousMonth),
                appliedToDate: endOfMonth(previousMonth),
            };
        }
        case DateRangeOptions.YEAR_TO_DATE: {
            return {
                appliedFromDate: startOfYear(now),
                appliedToDate: now,
            };
        }
        default:
            return {
                appliedFromDate: undefined,
                appliedToDate: undefined,
            };
    }
};
export { getDateRangeFromOption };
//# sourceMappingURL=dateUtils.js.map